import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { authApi } from '../../authApi';
import { type VerifyEmailRequest, type VerifyEmailResponse } from '../../types';
import type { TFormErrorResponse } from '@shared/types';
import { AxiosError } from 'axios';
import { showNotification } from '@shared/utils';
import { useNavigate } from 'react-router';
import { MutationKey } from '@shared/config';
import { useTranslation } from 'react-i18next';

export const useVerifyEmail = (): UseMutationResult<
  VerifyEmailResponse,
  AxiosError<TFormErrorResponse>,
  VerifyEmailRequest
> => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationKey: [MutationKey.VERIFY_EMAIL],
    mutationFn: (data: VerifyEmailRequest) => {
      return authApi.verifyEmail(data);
    },
    onSuccess: () => {
      showNotification({
        variant: 'success',
        message: t('auth.verifyEmailSuccess'),
      });

      navigate('/');
    },
    onError: error => {
      showNotification({
        error,
        variant: 'error',
        message: error.response?.data?.message || t('request.error'),
      });

      navigate('/');
    },
  });
};
